import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree
} from "vuex";
import suggestionUseCases from "../../../../domain/usecase/impl/suggestion/suggestionUseCases";

class SuggestionState {}

const state = new SuggestionState();

const mutations: MutationTree<SuggestionState> = {};

const actions: ActionTree<SuggestionState, SuggestionState> = {
  async suggestion(
    { commit },
    payload: { title: string; description: string }
  ): Promise<void> {
    try {
      return await suggestionUseCases.suggestion(payload.title, payload.description);
    } catch (e) {
      throw e;
    }
  }
};

const getters: GetterTree<SuggestionState, SuggestionState> = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<SuggestionState, SuggestionState>;
